/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Card, Col, Row,
} from 'react-bootstrap';
import { ReactComponent as IconPin } from 'assets/icons/pin.svg';
import { FutureInvestment } from 'types/FutureInvestment';
import opportunitiesBg from 'assets/img/opportunities-bg.png';
import numeral from 'numeral';
import { formatPercentOneDecimal } from 'utils/formats';
import ButtonImInterested from 'components/Opportunities/ButtonImInterested';

type OpportunityProps = {
  futureInvestment:FutureInvestment | null,
  opportunityInterestsme: ( ) => void
};
function Opportunity( {
  futureInvestment,
  opportunityInterestsme,
}: OpportunityProps ) {
  const { t } = useTranslation();

  const imageSrc = futureInvestment?.smallImageUrl?.trim()
    ? futureInvestment.smallImageUrl : opportunitiesBg;

  return (
    <Card className="h-100">
      <img src={imageSrc} className="card-img h-100" alt="..." />
      <div className="overlay" />

      <div className="card-img-overlay d-flex flex-column">
        <div className="content text-center">
          <h1 className="title-xl">NUEVA OPORTUNIDAD</h1>
          <p className="subtitle">Sé parte del nuevo proyecto de Impar Capital</p>
        </div>

        {!!futureInvestment && (
        <>
          <div className="text-center text-white">
            <p className="mb-1">
              {futureInvestment?.codigoPromocion}
            </p>
            <p className="subtitle mb-2">
              {futureInvestment?.tipoActivo}
              {( futureInvestment?.tipoActivo || futureInvestment?.provincia ) && (
                <IconPin className="mx-2" />
              )}
              {futureInvestment?.provincia}
            </p>
          </div>
          <div className="footer text-white">
            <Row className="gx-0">
              <Col xl={6} className="d-none d-xl-none">
                <p className="mb-1">
                  {futureInvestment?.codigoPromocion}
                </p>
                <p className="subtitle mb-2">
                  {futureInvestment?.tipoActivo}
                  {( futureInvestment?.tipoActivo || futureInvestment?.provincia ) && (
                  <IconPin className="mx-2" />
                  )}
                  {futureInvestment?.provincia}
                </p>
              </Col>
              <Col xs className="text-center">
                <p className="m-0 text--gray17">PLAZO</p>
                <p className="m-0 text--xmmd">
                  {`${futureInvestment?.plazoIinversion || 0} meses`}
                </p>
              </Col>
              <Col xs className="text-center">
                <p className="m-0 text--gray17">ROE</p>
                <p className="m-0 text--xmmd">
                  {numeral( futureInvestment?.roiEstimadoDespuesImpuestos
                    ? Number( futureInvestment?.roiEstimadoDespuesImpuestos ) / 100 : 0 )
                    .format( formatPercentOneDecimal )}
                </p>
              </Col>
              <Col xs className="text-center">
                <p className="m-0 text--gray17">TIR</p>
                <p className="m-0 text--xmmd">
                  {numeral( futureInvestment?.tirEstimadaDespuesImpuestos
                    ? Number( futureInvestment?.tirEstimadaDespuesImpuestos ) / 100 : 0 )
                    .format( formatPercentOneDecimal )}
                </p>
              </Col>
            </Row>
          </div>

          <Row className="mt-3 justify-content-end">
            <Col xs="auto">
              {!!futureInvestment?.invitacionOportunidadId && (
              <ButtonImInterested
                opportunityInterestsme={opportunityInterestsme}
              />
              )}

            </Col>
          </Row>
        </>
        )}
      </div>
    </Card>
  );
}

export default Opportunity;
